module.exports = __webpack_public_path__ + "img/paypal.6ba74624.svg";